import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import throttle from "lodash.throttle";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import useSound from "use-sound";
import { Parallax, ParallaxProvider } from "react-scroll-parallax";
import { useMediaQuery } from "react-responsive";
import Heade from "./header.jsx";
import lock from "../../assets/svg/Lock.png"
// Context
import { MainContext } from "../../components/context/context";

// Components
import ConnectWallet from "../../components/ConnectWallet/ConnectWallet";
import Loading from "./Loading.jsx";

// Assets
import { ReactComponent as Curve } from "../../assets/svg/curve.svg";
import { ReactComponent as ChooseYourSide } from "../../assets/svg/choose-your-side-1.svg";
import { ReactComponent as ScrollToIcon } from "../../assets/svg/scroll-to-2.svg";
import { ReactComponent as NoAnnouncementCurve } from "../../assets/svg/no-announcement.svg";
import { ReactComponent as VolumeOn } from "../../assets/media/icons/volumeOn.svg";
import { ReactComponent as VolumeOff } from "../../assets/media/icons/volumeOff.svg";
import "./Header.scss"; // Add custom CSS for pixel-perfect alignment
import x from "../../assets/svg/X.png"
import discord from "../../assets/svg/Discord.png"
import team from "../../assets/svg/Team.png"
import allowlist from "../../assets/svg/Allowlist.png"
import ecosystem from "../../assets/svg/Ecosystem.png"
import connect from "../../assets/svg/Wallet.png"
import volumeOn from "../../assets/svg/MusicOn.png"
import logo from "../../assets/svg/Logo (1).png"
// Sounds
import hoverSound from "../../assets/sound/WindSwoosh.wav";
import volumeOff from "../../assets/svg/MusicOff.png"
import Email from "./email.jsx"

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
const BearBullChoose = ({ currentSection }) => {
  const isVisible = currentSection ;
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });
  const isSmallerDevice = useMediaQuery({ query: "(max-width: 1024px)" });
  const navigate = useNavigate();
  const announcementText = "Allowlist Quests";
 
  // If the announcement text is empty, the coin gif will be displayed instead
  const { isSoundEnabled, setIsSoundEnabled } = useContext(MainContext);

  const [imagesLoaded, setImagesLoaded] = useState(false);

  const [bearKingGif, setBearKingGif] = useState(
    "assets/bear-bull-game/landing-bearking-idle.gif"
  );
  const [bullKingGif, setBullKingGif] = useState(
    "/assets/bear-bull-game/landing-bullking-idle.gif"
  );
  const [hovered, setHovered] = useState(false);
  const [hovered1, setHovered1] = useState(false);
  const [hovered2, setHovered2] = useState(false);
  const [playHoverSound] = useSound(hoverSound, {
    volume: 0,
    interrupt: true,
  });

  const [chosenSide, setChosenSide] = useState(null);

  const handleMouseEnter = () => {
    isSoundEnabled && playHoverSound();
    setBearKingGif(
      "/assets/bear-bull-game/bearking-outlined-transitiontoselected.gif"
    );

    setTimeout(() => {
      setBearKingGif("/assets/bear-bull-game/bearking-outlined-selected.gif");
    }, 350);
  };

  const handleMouseLeave = throttle(() => {
    setBearKingGif(
      "/assets/bear-bull-game/bearking-nooutline-transitiontoidle.gif"
    );

    setTimeout(() => {
      setBearKingGif("/assets/bear-bull-game/landing-bearking-idle.gif");
    }, 300);
  }, 310);

  const handleMouseEnterBull = throttle(() => {
    isSoundEnabled && playHoverSound();
    setBullKingGif(
      "/assets/bear-bull-game/bullking-outlined-transitiontoselected.gif"
    );

    setTimeout(() => {
      setBullKingGif("/assets/bear-bull-game/bullking-outlined-selected.gif");
    }, 250);
  }, 260);

  const handleMouseLeaveBull = throttle(() => {
    if (chosenSide !== "bull") {
      setBullKingGif(
        "/assets/bear-bull-game/bullking-nooutline-transitiontoidle.gif"
      );
      setTimeout(() => {
        setBullKingGif("/assets/bear-bull-game/landing-bullking-idle.gif");
      }, 300);
    }
  }, 310);

  useEffect(() => {

    document.title = "Fortune Foes";

  
    
  }, []);

  

  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = resolve;
      img.onerror = reject;
    });
  };
 console.log(currentSection)
  useEffect(() => {
    const imgTagsSources = [
      "assets/bear-bull-game/landing-bearking-idle.gif",
      "/assets/bear-bull-game/landing-bullking-idle.gif",
      "/assets/bear-bull-game/bearking-outlined-transitiontoselected.gif",
      "/assets/bear-bull-game/bearking-outlined-selected.gif",
      "/assets/bear-bull-game/bearking-nooutline-transitiontoidle.gif",
      "/assets/bear-bull-game/bullking-outlined-transitiontoselected.gif",
      "/assets/bear-bull-game/bullking-outlined-selected.gif",
      "/assets/bear-bull-game/bullking-nooutline-transitiontoidle.gif",
    ];

    const cssBackgroundSources = [
      "/assets/bear-bull-game/landing-riverside.gif",
      "/assets/bear-bull-game/cloud-left.png",
      "/assets/bear-bull-game/cloud-right.png",
      "/assets/bear-bull-game/castle-left.gif",
      "/assets/bear-bull-game/castle-right.gif",
      "/assets/bear-bull-game/landing-cliffright.png",
      "/assets/bear-bull-game/landing-cliffleft.png",
    ];

    Promise.all([...imgTagsSources, ...cssBackgroundSources].map(loadImage))
      .then(() => setImagesLoaded(true))
      .catch((err) => console.error("Error loading images", err));
  }, []);

  useEffect(() => {
    const preloadAssets = () => {
      const assetsToPreload = [
        require("../../assets/media/Home/Foreground.png"),
        require("../../assets/media/Home/Collumn.png"),
        require("../../assets/media/Home/Statues.png"),
        require("../../assets/media/Home/Stairs.png"),
        require("../../assets/media/Intro/Hall/Torches-Left.gif"),
        require("../../assets/media/Intro/Hall/Torches-Right.gif"),
        require("../../assets/media/images/bearbull.png"),
        require("../../assets/media/images/Bear-Popup-Home.png"),
        require("../../assets/media/images/Bear-Popup.png"),
        require("../../assets/media/icons/TwitterPixel.png"),
        require("../../assets/media/icons/DiscordPixel.png"),
        require("../../assets/media/Intro/Hall/Anubis-D2_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Anubis-H2_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/BearKing_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/BearKing-H_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Lich-D_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Lich-H_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Demon-D_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Sage-D_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Sage-H_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/moneybagBearDark.webm"),
        require("../../assets/media/Intro/Hall/moneybagBearHover.webm"),
        require("../../assets/media/Intro/Hall/Bullish-D_scaled_2x_minified.gif"),
        require("../../assets/media/Intro/Hall/Bullish-H_scaled_2x_minified.gif"),
        require("../../assets/media/Home/FloorBull.png"),
      require("../../assets/media/Home/CollumnBull.png"),
      require("../../assets/media/Home/StatuesBull.png"),
      require("../../assets/media/Home/StairsBull.png"),
      require("../../assets/media/Intro/Hall/Torches-Left (2).gif"),
      require("../../assets/media/Intro/Hall/Torches-Right (2).gif"),
      require("../../assets/media/images/bearbull.png"),
      require("../../assets/media/images/Bull-Popup-Home.png"),
      require("../../assets/media/images/Bull-Popup.png"),
      require("../../assets/media/icons/TwitterPixel.png"),
      require("../../assets/media/icons/DiscordPixel.png"),
      require("../../assets/media/Intro/Hall/Treasurer-D_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/Treasurer-H_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/BullKing_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/BullKing-H_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/Death-D_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/Death-H_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/AdvisorP-D_scaled_2x_minified (1).gif"),
      require("../../assets/media/Intro/Hall/AdvisorP-H_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/Samurai-D_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/Samurai-H_scaled_2x_minified.gif"),
      require("../../assets/media/Intro/Hall/BGBull.png"),
      require("../../assets/media/Intro/Hall/BG.png"),
      ];
  
      assetsToPreload.forEach((src) => {
        const fileType = typeof src === "string" && src.endsWith(".webm") ? "video" : "image";
        if (fileType === "image") {
          const img = new Image();
          img.src = src;
        } else {
          const video = document.createElement("video");
          video.src = src;
          video.preload = "auto";
        }
      });
    };
  
    preloadAssets();
  }, []);
  
  

  // const handleChosenBear = () => {
  //   document.body.style.overflow = "hidden";
  //   document.body.style.height = "100vh";

  //   setTimeout(() => {
  //     navigate("/bears-hall");
  //   }, 1000);
  // };

  return (
    <>
      <div
        className={
          imagesLoaded
            ? "initial-loading-wrapper hide"
            : "initial-loading-wrapper"
        }
      >
        <img
          draggable="false"
          className="initial-loading-gif"
          src="/assets/loading.gif"
          alt="loading"
        />
      </div>
      <ParallaxProvider>
   
        <section className="bear-bull-choose">
 
        <div className="header-top-wrapper">
          <header className="header">
<div className="header-left">
  <div className="icon-button"  
               >
    <img src={x} alt="X"  onClick={() =>
                  window.open("https://x.com/fortunefoes", "_blank")
                }/>
  </div>
  <div className="icon-button">
    <img src={discord} alt="Discord"    onClick={() =>
                  window.open("https://discord.gg/Foes", "_blank")
                }/>
  </div>
  <div
      className="icon-button"
      onMouseEnter={() => setHovered2(true)}
      onMouseLeave={() => setHovered2(false)}
    >

        <img
          src={allowlist}
          alt="Team"
          style={{
            position: 'absolute',

            opacity: hovered2 ? 0 : 0.9,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />
        <img
          src={lock}
          alt="Locked"
          style={{
            position: 'relative',
            opacity: hovered2 ? 0.9 : 0,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />

      <span className="mt-1 text-sm">ALLOWLIST</span>
    </div> 
    <div
      className="icon-button"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >

        <img
          src={ecosystem}
          alt="Team"
          style={{
            position: 'absolute',

            opacity: hovered ? 0 : 0.9,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />
        <img
          src={lock}
          alt="Locked"
          style={{
            position: 'relative',
            opacity: hovered ? 0.9 : 0,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />

      <span className="mt-1 text-sm">ECOSYSTEM</span>
    </div>

  <div
      className="icon-button"
      onMouseEnter={() => setHovered1(true)}
      onMouseLeave={() => setHovered1(false)}
    >

        <img
          src={team}
          alt="Team"
          style={{
            position: 'absolute',

            opacity: hovered1 ? 0 : 0.9,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />
        <img
          src={lock}
          alt="Locked"
          style={{
            position: 'relative',
            opacity: hovered1 ? 0.9 : 0,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />

      <span className="mt-1 text-sm">TEAM</span>
    </div>



</div>
<div
          className="header-center"
 
        >
          <div className="center-content ">
            <img src={logo} alt="Team" style={{ width: "80%" }} />
            <div className="choose-your-cult"          style={{
            opacity: isVisible == 0 ? 1 : 0,
            pointerEvents: isVisible ? "auto" : "none",
            transition: "opacity 0.5s ease",
          }}>CHOOSE YOUR SIDE</div>
          </div>
        </div>
        <div className="header-right">
          <div className="icon-button-right"  onClick={() => {
                  setIsSoundEnabled(!isSoundEnabled);
                }}>
          {isSoundEnabled ?   <img src={volumeOn}  alt="Music On" /> :  <img src={volumeOff}  alt="Music On" /> }

          </div>

         
          <ConnectWallet />

        </div>
      </header>
            <div className="buttons-wrapper">
          
        

              {/* TODO: UNCOMMENT THIS */}
              {/* <button
                onClick={() =>
                  window.open("https://dev.bears-btc-sim.pages.dev/", "_blank")
                }
                className="game-btn bear-bull-btn"
              >
                ETH SIM
              </button>
              <button
                onClick={() =>
                  window.open("https://barbearians-pl.pages.dev", "_blank")
                }
                className="game-btn bear-bull-btn"
              >
                PNL
              </button> */}
            </div>
           { /*<div className="choose-your-side-container">
              <div className="choose-your-side-wrapper">
                <p className="choose-your-side-text">CHOOSE YOUR SIDE</p>
                <ChooseYourSide className="choose-your-side-svg" />
              </div>
            </div>*/}

            {/*<div className="bear-bull-nav-right-side">
              <div
                onClick={() => {
                  setIsSoundEnabled(!isSoundEnabled);
                }}
                className="volume-button-wrapper"
              >
                {isSoundEnabled ? <VolumeOn /> : <VolumeOff />}
              </div>

              <div className="connect-wallet-bear-bull-game">
                <ConnectWallet />
              </div>
            </div>*/}
          </div>

          <div className="bear-bull-choose-sky" />

          <div
            translateY={!isMobile ? 2.5 : 0}
            className="bear-bull-riverside"
          />

          <div translateY={1} className="clouds-left" />

          <div translateY={1} className="clouds-right" />

     

          <div className="bear-bull-cliffright" />

          <Parallax className="bear-bull-cliffleft" />

          {/* Characters */}
          <Parallax className="bear-king-wrapper"  >
            <img
              src="/assets/bear-bull-game/Bear-Popup.png"
              draggable="false"
              className="gray-lock"
              alt=""
            />
            <img
              draggable="false"
              src={bearKingGif}
              alt=""
              className="landing-bearking-idle"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            />
          </Parallax>

          <Parallax
            onMouseEnter={handleMouseEnterBull}
            onMouseLeave={handleMouseLeaveBull}
            className="bull-king-wrapper parallax"
      
            data-depth="0.325"
          >
            <img
              src="/assets/bear-bull-game/Bull-Popup.png"
              draggable="false"
              className="gray-lock"
              alt=""
            />
            <img
              draggable="false"
              src={bullKingGif}
              alt=""
              className="landing-bullking-idle"
            />
          </Parallax>
          <div className="bottom-header-wrapper">


            <Email/>

            <div className="header-top-wrapper1">
          <header className="header">
<div className="header-left1">
  <div className="icon-button"  
               >
    <img src={x} alt="X"  onClick={() =>
                  window.open("https://x.com/fortunefoes", "_blank")
                }/>
  </div>
  <div className="icon-button">
    <img src={discord} alt="Discord"    onClick={() =>
                  window.open("https://discord.gg/Foes", "_blank")
                }/>
  </div>
  <div
      className="icon-button"
      onMouseEnter={() => setHovered2(true)}
      onMouseLeave={() => setHovered2(false)}
    >

        <img
          src={allowlist}
          alt="Team"
          style={{
            position: 'absolute',

            opacity: hovered2 ? 0 : 0.9,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />
        <img
          src={lock}
          alt="Locked"
          style={{
            position: 'relative',
            opacity: hovered2 ? 0.9 : 0,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />

      <span className="mt-1 text-sm">ALLOWLIST</span>
    </div> 
    <div
      className="icon-button"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >

        <img
          src={ecosystem}
          alt="Team"
          style={{
            position: 'absolute',

            opacity: hovered ? 0 : 0.9,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />
        <img
          src={lock}
          alt="Locked"
          style={{
            position: 'relative',
            opacity: hovered ? 0.9 : 0,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />

      <span className="mt-1 text-sm">ECOSYSTEM</span>
    </div>

  <div
      className="icon-button"
      onMouseEnter={() => setHovered1(true)}
      onMouseLeave={() => setHovered1(false)}
    >

        <img
          src={team}
          alt="Team"
          style={{
            position: 'absolute',

            opacity: hovered1 ? 0 : 0.9,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />
        <img
          src={lock}
          alt="Locked"
          style={{
            position: 'relative',
            opacity: hovered1 ? 0.9 : 0,
            transition: 'opacity 0.7s ease',
            pointerEvents: 'none',
          }}
        />

      <span className="mt-1 text-sm">TEAM</span>
    </div>



</div>
 
        <div className="header-right1">
          <div className="icon-button-right"  onClick={() => {
                  setIsSoundEnabled(!isSoundEnabled);
                }}>
          {isSoundEnabled ?   <img src={volumeOn}  alt="Music On" /> :  <img src={volumeOff}  alt="Music On" /> }
          </div>
          <ConnectWallet />
        </div>
      </header>
            <div className="buttons-wrapper">
          
        

              {/* TODO: UNCOMMENT THIS */}
              {/* <button
                onClick={() =>
                  window.open("https://dev.bears-btc-sim.pages.dev/", "_blank")
                }
                className="game-btn bear-bull-btn"
              >
                ETH SIM
              </button>
              <button
                onClick={() =>
                  window.open("https://barbearians-pl.pages.dev", "_blank")
                }
                className="game-btn bear-bull-btn"
              >
                PNL
              </button> */}
            </div>
           { /*<div className="choose-your-side-container">
              <div className="choose-your-side-wrapper">
                <p className="choose-your-side-text">CHOOSE YOUR SIDE</p>
                <ChooseYourSide className="choose-your-side-svg" />
              </div>
            </div>*/}

            {/*<div className="bear-bull-nav-right-side">
              <div
                onClick={() => {
                  setIsSoundEnabled(!isSoundEnabled);
                }}
                className="volume-button-wrapper"
              >
                {isSoundEnabled ? <VolumeOn /> : <VolumeOff />}
              </div>

              <div className="connect-wallet-bear-bull-game">
                <ConnectWallet />
              </div>
            </div>*/}
          </div>
          </div>
   
          {/* <div className="bottom-header-wrapper">
            <p className="bear-bull-game-logo">
              BEAR <span>&</span> BULL GAME
            </p>
            <div
              onClick={() => navigate("/allowlist")}
              className={
                announcementText
                  ? "announcement-wrapper"
                  : "announcement-wrapper empty-announcement"
              }
            >
              {announcementText && (
                <img
                  src="/assets/bear-bull-game/Allowlist-Scroll.png"
                  draggable="false"
                  className="announcement-img"
                  alt=""
                />
              )}
              {announcementText ? (
                <p className="announcement-text">{announcementText}</p>
              ) : (
                <>
                  <NoAnnouncementCurve className="announcement-curve" />
                  <img
                    src="/assets/bear-bull-game/coin.gif"
                    draggable="false"
                    className="announcement-coin-gif"
                  />
                </>
              )}

              {announcementText !== "" && (
                <div>
                  <Curve className="announcement-curve left" />
                  <Curve className="announcement-curve right" />
                </div>
              )}
            </div>

            <button onClick={handleScrollTo} className="next-section-btn">
              <ScrollToIcon className="scroll-to-icon" />
            </button>
          </div> */}


        </section>
 
      </ParallaxProvider>
    
    </>
  );
};

export default BearBullChoose;
